import React from 'react';
import {
  makeStyles,
  Box,
  Container,
  Typography,
  ButtonBase
} from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  cta: {
    backgroundImage: 'url(/static/beyond-accounting/payroll/layered-waves.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  button: {
    height: 52,
    borderRadius: 23,
    border: '2px solid #fff',
    backgroundColor: 'transparent',
    color: '#fff',
    width: '100%',
    transition: 'all 0.5s',
    fontSize: '1.2rem',
    fontWeight: 500,
    maxWidth: 600,
    '&:hover': {
      backgroundColor: '#fff',
      color: '#ff7704'
    }
  }
}));

/**
 *
 * @param {object} param
 * @param {pageCTA} param.pageDetails
 * @returns
 */
const CTATl1 = ({ pageDetails }) => {
  const { cta, button } = useStyles();

  return (
    <Box className={cta}>
      <Container maxWidth="lg">
        <Box
          minHeight={400}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            maxWidth={800}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography
              style={{
                fontSize: '2.2rem',
                fontWeight: 900,
                marginBottom: '0.4em',
                textAlign: 'center',
                color: '#fff'
              }}
            >
              {pageDetails?.text || ''}
            </Typography>
            <ButtonBase
              fullWidth
              className={button}
              component={Link}
              to="/contact-us"
            >
              <Typography>Book a Demo</Typography>
            </ButtonBase>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CTATl1;
